module.exports = __webpack_public_path__ + "static/img/hand3.6d3dfe25.png";